module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kpipa_m.78b1b443464e089ac4e41d58d6d8f5c0.png";